/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const Language = {
    En: 'EN',
    Es: 'ES'
} as const;
export type Language = typeof Language[keyof typeof Language];

